export default "__VITE_ASSET__TIhQc7Bl__"